import { useState } from 'react'
import { TamaguiProvider } from '@tamagui/core'
import { tamaguiConfig } from '@giffgaff/fe-design-system-ui'

import type { ReactNode } from 'react'

// TamaguiProvider only injects its CSS in the browser, so the server HTML of a
// feds-ui component is unstyled without this inline stylesheet. It renders
// after the children because some atomic rules register during render. The
// same pattern as fe-common's HeaderStyles and FooterStyles.
function TamaguiStyles({ id }: { id: string }) {
  const [css] = useState(() => tamaguiConfig.getCSS())

  return (
    <style
      dangerouslySetInnerHTML={{ __html: css }}
      suppressHydrationWarning
      id={id}
    />
  )
}

export default function TamaguiScope({
  children,
  styleId,
}: {
  children: ReactNode
  styleId: string
}) {
  return (
    <>
      <TamaguiProvider
        disableInjectCSS
        config={tamaguiConfig}
        defaultTheme="light"
      >
        {children}
      </TamaguiProvider>
      <TamaguiStyles id={styleId} />
    </>
  )
}
